<template>
    <div class="policy-version-stack">
        <ChildPrivacyPolicy20260226Content />
        <PersonalInfoPolicy20260226Content />
    </div>
</template>

<script>
import ChildPrivacyPolicy20260226Content from '@/views/policy/common/ChildPrivacyPolicy20260226Content.vue';
import PersonalInfoPolicy20260226Content from '@/views/policy/common/PersonalInfoPolicy20260226Content.vue';

export default {
    name: 'ChildPolicy20260226',
    components: {
        ChildPrivacyPolicy20260226Content,
        PersonalInfoPolicy20260226Content,
    },
};
</script>
